// extracted by mini-css-extract-plugin
export var bonusBox = "DepositBonus-module--bonusBox--91847";
export var clampSpacer = "DepositBonus-module--clampSpacer--fc7f5";
export var compact = "DepositBonus-module--compact--a1ea5";
export var depositBonusHeader = "DepositBonus-module--depositBonusHeader--2702e";
export var depositBonusHeaderContent = "DepositBonus-module--depositBonusHeaderContent--b4003";
export var fontWeightBold = "DepositBonus-module--fontWeightBold--37a50";
export var greenText = "DepositBonus-module--greenText--31d1b";
export var leftClamp = "DepositBonus-module--leftClamp--18605";
export var rdmBar = "DepositBonus-module--rdmBar--602af";
export var rdmBarClaimed = "DepositBonus-module--rdmBarClaimed--ec594";
export var rdmBarPendingDeposit = "DepositBonus-module--rdmBarPendingDeposit--48891";
export var rdmBarPill = "DepositBonus-module--rdmBarPill--9a167";
export var rdmBarSlideBox = "DepositBonus-module--rdmBarSlideBox--513f8";
export var rdmBarSlideBoxTrigger = "DepositBonus-module--rdmBarSlideBoxTrigger--de8a2";
export var rdmContainer = "DepositBonus-module--rdmContainer--6b5d9";
export var rdmKey = "DepositBonus-module--rdmKey--6e7da";
export var rightClamp = "DepositBonus-module--rightClamp--74430";
export var shinyText = "DepositBonus-module--shinyText--9a3bd";
export var subTitle = "DepositBonus-module--subTitle--c2f82";
export var title = "DepositBonus-module--title--4c337";
export var yellowText = "DepositBonus-module--yellowText--bf882";